import { SubjectiveCharacteristic } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const sliderAdjustment = createAction<{
  id: string;
  field: SubjectiveCharacteristic;
  newValue: number;
}>('sliderAdjustment');
